import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWc = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_895_1462",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_895_1462)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.82703 21.7501V14.5001H4.32703V9.00007C4.32703 8.51424 4.49719 8.10107 4.83753 7.76057C5.17786 7.42024 5.59103 7.25007 6.07703 7.25007H8.92303C9.40903 7.25007 9.82219 7.42024 10.1625 7.76057C10.5029 8.10107 10.673 8.51424 10.673 9.00007V14.5001H9.17303V21.7501H5.82703ZM6.19328 5.69133C5.83361 5.33183 5.65378 4.89633 5.65378 4.38483C5.65378 3.87316 5.83361 3.43757 6.19328 3.07807C6.55294 2.71841 6.98853 2.53857 7.50003 2.53857C8.01153 2.53857 8.44711 2.71841 8.80678 3.07807C9.16644 3.43757 9.34628 3.87316 9.34628 4.38483C9.34628 4.89633 9.16644 5.33183 8.80678 5.69133C8.44711 6.05099 8.01153 6.23082 7.50003 6.23082C6.98853 6.23082 6.55294 6.05099 6.19328 5.69133ZM15.25 21.7501V16.0001H12.5385L14.8193 8.42708C14.9334 8.05141 15.144 7.76133 15.451 7.55683C15.758 7.35233 16.1077 7.25007 16.5 7.25007C16.8924 7.25007 17.242 7.35233 17.549 7.55683C17.856 7.76133 18.0666 8.05141 18.1808 8.42708L20.4615 16.0001H17.75V21.7501H15.25ZM15.1933 5.69133C14.8336 5.33183 14.6538 4.89633 14.6538 4.38483C14.6538 3.87316 14.8336 3.43757 15.1933 3.07807C15.5529 2.71841 15.9885 2.53857 16.5 2.53857C17.0115 2.53857 17.4471 2.71841 17.8068 3.07807C18.1664 3.43757 18.3463 3.87316 18.3463 4.38483C18.3463 4.89633 18.1664 5.33183 17.8068 5.69133C17.4471 6.05099 17.0115 6.23082 16.5 6.23082C15.9885 6.23082 15.5529 6.05099 15.1933 5.69133Z",
			fill: "currentColor"
		})
	})]
});
export default SvgWc;
